import { handleError } from './error-handler';

const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded'
}

const generateUrl = (url, params) => {
	let paramsUrl = new URL(url);

	Object.keys(params).forEach(key => {
		if (Array.isArray(params[key])) {
			params[key].forEach(element => paramsUrl.searchParams.append(`${key}\[\]`, element));
		} else paramsUrl.searchParams.append(key, params[key]);
	});

    return paramsUrl;
}

export const get = async (url, params) => {
    if (params) url = generateUrl(url, params);

    
    try {
        const request = await fetch(url, {
            method: 'GET',
            headers,
            params
        });
        const response = await request.json();
        if (!request.ok) throw request.status;
        return response;
    } catch (error) {
        handleError(error);
    }
}

export const post = async (url, data, params) => {
	if (params) url = generateUrl(url, params);
	const body = JSON.stringify(data);

    try {
        const request = await fetch(url, {
            method: 'POST',
            body,
            headers
        });
        const response = await request.json();
        if (!request.ok) throw request.status;
        return response;
    } catch (error) {
        handleError(error);
    }
}

export const put = async (url, data, params) => {
	if (params) url = generateUrl(url, params);
    const body = JSON.stringify(data);

    try {
        const request = await fetch(url, {
            method: 'PUT',
            body,
            headers
        });
        const response = await request.json();
        if (!request.ok) throw request.status;
        return response;
    } catch (error) {
        handleError(error);
    }
}

const dataManager = {
    install: (Vue) => {
        Vue.prototype.$get = (url, params) => get(url, params);
        Vue.prototype.$post = (url, data, params) => post(url, data, params);
        Vue.prototype.$put = (url, data, params) => put(url, data, params);
    }
}

export default dataManager;